/**
 * Vite entry point for the Wizard Cleaning WA child theme.
 */

// Parent theme modules.
import '@jivemedia/wp-theme-base/mobile-drawer';
import '@jivemedia/wp-theme-base/nav-disclosure';

// CSS imports.
import '../css/main.css';

// TypeScript imports.
import './category-filter.ts';
import './enquiry-modal.ts';
import './reviews.ts';

// TypeScript dynamic imports.
if (document.querySelector('[data-swiper]')) {
	void import('./carousels.ts');
}
